<script>
export default {
  components: {

  },
  props: {
    defaultValue: {
      type: Object,
      default: () => { }
    },
    value: {
      type: Object,
      default: () => { }
    },
    allUserGroups: {
      type: Array,
      default: () => []
    },
    permission: {
      type: [Array, Boolean],
      default: () => [] || false
    },
    cachedProducts: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      radio: '1',
      checkList: [],
      cloneAllUserGroups: [],
      superManager: false
    }
  },
  computed: {
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    submitRules() {
      return {
        userGroupIds: [
          {
            required: true,
            message: '請選擇角色',
            trigger: 'change',
          },
          // {
          //   validator: (rule, value, callback) => {
          //     // console.log(rule, value, callback)
          //   }
          // }
        ],
        userGroupStoreIds: [
          {
            required: true,
            message: '請選擇負責分店',
            trigger: 'change',
          },
        ],
        // checkList: [
        //   {
        //     required: true,
        //     message: '請選擇角色',
        //   },
        // ]
      }
    },
    isEditMode() {
      return this.submitData.id ? true : false
    }
  },
  watch: {
    checkList(nvl) {
    }
  },
  created() {
    // 過渡期： 因為帳號只剩一個人事這邊能呈現（過往一些放在帳號管理的帳號就無法查看，故如果需要加入到人事裡要重新加入）
    // 如果是幫超級使用者加入帳號，先判斷他是否是超級使用者，是的話給他勾選，另外 userGroups 和 userGroupIds 要幫他加入全部
    if (this.defaultValue.userGroupIds && this.defaultValue.userGroupIds.length > 0 && this.defaultValue.userGroupIds.includes(7)) {
      this.superManager = true
    }
    try {
      // if (this.value.userGroups && this.value.userGroups.length > 0) {
      //   this.value.userGroups.forEach(item => this.checkList.push(item.id))
      // }
      if (this.superManager) {
        this.submitData.userGroups = [...this.allUserGroups]
        this.submitData.userGroupIds = [...this.defaultValue.userGroupIds]
        // for (let i = 0, len = this.allUserGroups.length; i < len; i++) {

        //   this.checkList.push(this.allUserGroups[i].id)
        //   // this.submitData.userGroups = this.defaultValue.userGroups
        //   // this.submitData.userGroupIds = this.defaultValue.userGroupIds
        // }
      }
    } catch (error) {
      console.error(error.message)
    }
  },
  mounted() {
  },
  methods: {
    /**
     * @description checkboxgroup互斥
     */
    checkListRule(item) {
      if (this.superManager || item.title === '商店擁有者') {
        return true
      }
      // 下方為互斥條件：有分店，不能選商店。有商店，不能選分店
      if (this.submitData.userGroupIds.includes(12) && item.id === 8) {
        return true
      }
      if (this.submitData.userGroupIds.includes(8) && item.id === 12) {
        return true
      }
    },
    /**
     * @description 判斷此帳號權限能編輯的角色
     */
    permissionBigger(item) {
      const { userGroups } = this.$router.currentRoute.params // 所有權限
      const { currentUser } = this.$store.state.auth
      let loginStaffIndex = 0
      let windowStaffIndex = 0
      if (userGroups?.length > 0) {
        windowStaffIndex = userGroups.findIndex(groupItem => groupItem.id === item.id)
      }
      if (currentUser.groups && currentUser.groups.length > 0) {
        const thisStaffPermission = currentUser.groups[0] // 這個登入職員的最大權限
        loginStaffIndex = userGroups.findIndex(item => item.id === thisStaffPermission) // 這個登入職員的最大權限index
      }
      if (loginStaffIndex > windowStaffIndex && this.isEditMode) {
        return true
      }
      if (loginStaffIndex >= windowStaffIndex && !this.isEditMode) {
        return true
      }
    },
    validateSelf() {
      let check = true
      if (this.superManager) return true
      if (this.submitData.userGroupIds.length === 0) {
        this.$message({
          type: 'error',
          message: `請選擇角色`,
        })
        check = false
      }
      if (this.submitData.userGroupIds.includes(12) && this.submitData.userGroupStoreIds.length === 0 && !this.superManager) {
        this.$message({
          type: 'error',
          message: `請選擇分店`,
        })
        check = false
      }
      if (!this.submitData.userGroupIds.includes(12)) {
        this.submitData.userGroupStoreIds = []
      }
      if (!check) {
        return new Promise(function (resolve, reject) {
          reject(new Error(''));
        });
      } else {
        return check
      }

    },
    openSelectUser() { },
    /**
     * @description 選擇角色時，點到哪個觸發事件
     */
    handleCheckedPermission(type) {
      const selectUserGrops = this.allUserGroups.filter((item) => {
        return type.includes(item.id)
      })
      this.submitData.userGroups = selectUserGrops.length ? [...selectUserGrops] : []
      if (!this.submitData.userGroupIds.includes(12)) {
        this.submitData.userGroupStoreIds = []
      }
      // this.cloneAllUserGroups = JSON.parse(JSON.stringify(this.allUserGroups))
      // this.submitData.userGroupIds = []
      // this.submitData.userGroups = []
      // for (let i = 0, len = type.length; i < len; i++) {
      //   let data = this.cloneAllUserGroups.find(item => item.title === type[i])
      //   this.value.userGroups.push(data)
      //   this.value.userGroupIds.push(data.id)
      // }
    },
  },
}
</script>
<template>
  <div :class="$style.permissionStyle">
    <el-form ref="form" :model="submitData" :rules="submitRules" :class="$style.permissionC" label-position="top"
      class="el-form--floating" :validate-on-rule-change="false">
      <!-- <el-row :gutter="20">
            <h4>選擇角色</h4>
            <el-button class="is-round" @click="openSelectUser">
                <BaseIcon name="user-plus" />
                <span>角色列表</span>
            </el-button>
        </el-row> -->
      <h4>選擇角色</h4>
      <!-- <el-col :sm="12" :span="24">
          <el-form-item label="角色" prop="title" class="is-border is-padding is-round">
            <el-radio v-model="radio" label="1">初次預約才需填寫</el-radio>
          </el-form-item>
        </el-col>
        <el-col :sm="12" :span="24">
          <el-form-item label=" " prop="title" class="red is-border is-padding is-round is-empty-label is-required">
            <el-radio v-model="radio" label="2">每次預約需填寫</el-radio>
          </el-form-item>
        </el-col> -->
      <el-row :gutter="24" :class="$style.marginLabel">
        <el-form-item label="角色" prop="userGroupIds" required>
          <el-checkbox-group v-model="submitData.userGroupIds" @change="handleCheckedPermission">
            <el-col v-for="(item, index) in allUserGroups" :key="index" :span="12">
              <el-checkbox :label="item.id" border :disabled="(checkListRule(item) || permissionBigger(item))"
                class="w-100 mb-3 isStyleBigHeight">{{ item.title }}</el-checkbox>
            </el-col>
          </el-checkbox-group>
        </el-form-item>
      </el-row>
      <el-row>
        <!-- <el-col v-if="permission" :md="12"> -->
        <el-form-item v-if="permission && !superManager" label="負責分店（可複選）" prop="userGroupStoreIds">
          <el-checkbox-group v-model="submitData.userGroupStoreIds">
            <el-checkbox v-for="store in cachedProducts" :key="store.id" :label="store.id">{{ store.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- </el-col> -->
      </el-row>
    </el-form>
  </div>
</template>

<style lang="scss" module>

.permissionStyle {
  background-color: white;
}

.permissionC {
  padding: 18px 20px;

  :global {
    .el-form-item__label {
      // &:first-child {
      // margin-left: 20px;
      // }
    }

    .el-checkbox__inner {
      border-radius: 14px;
    }
  }
}

.marginLabel {
  :global {
    .el-form-item__label {
      margin-left: 20px;
    }
  }
}
</style>